export const services = [
  {
    id: 'social-media-marketing',
    slug: 'social-media-marketing',
    title: 'Social Media Marketing',
    icon: 'Share2',
    shortDesc:
      'Build a powerful brand presence across social platforms with data-driven strategies that increase engagement, grow your audience, and convert followers into loyal customers.',
    outcome: 'Increase brand awareness and generate qualified social leads',
    metaTitle: 'Social Media Marketing Agency India | Markivox',
    metaDesc:
      'Expert social media marketing services in India. Build brand awareness, grow your audience, and generate qualified leads with Markivox.',
    heroH1: 'Social Media Marketing Services That Build Brands and Drive Real Leads',
    intro: [
      "In today's digital-first world, your social media presence is often the first impression your brand makes on potential customers. Social media marketing is not just about posting content — it's about building meaningful connections with your target audience, establishing authority in your industry, and creating a consistent pipeline of potential customers who trust your brand before they ever contact you.",
      "At Markivox, we deliver strategic social media marketing services that go beyond vanity metrics like likes and followers. Our approach is rooted in data, audience psychology, and platform-specific best practices to ensure every rupee of your social media budget delivers measurable, business-relevant returns. Whether you're a startup building brand awareness or an established business looking to scale, we craft strategies tailored to your specific growth goals.",
      "We manage end-to-end social media operations — from strategy and content creation to community management and paid amplification — giving you a fully managed solution that drives results without demanding your time.",
    ],
    benefits: [
      {
        title: 'Targeted Audience Reach',
        desc: "We identify and reach your ideal customers on platforms where they spend their time, using advanced targeting capabilities to minimize wasted budget and maximize relevant exposure.",
      },
      {
        title: 'Brand Authority Building',
        desc: 'Consistent, high-quality content positions your brand as an authority in your industry, increasing trust and customer confidence before the first conversation.',
      },
      {
        title: 'Lead Generation Funnels',
        desc: 'Our social media funnels are designed to capture leads and drive traffic to your website, converting social followers into paying customers through strategic calls-to-action.',
      },
      {
        title: 'Community Management',
        desc: 'We monitor, respond to, and engage with your community daily, building customer relationships that drive repeat business and word-of-mouth referrals.',
      },
      {
        title: 'Performance Analytics',
        desc: 'Detailed monthly reports give you full transparency into campaign performance, audience growth, engagement trends, and the ROI of every campaign we run.',
      },
    ],
    process: [
      {
        step: '01',
        title: 'Audit & Strategy',
        desc: 'We begin with a comprehensive audit of your existing social presence, competitor analysis, and audience research to build a tailored, goals-aligned strategy.',
      },
      {
        step: '02',
        title: 'Content Planning',
        desc: 'Our team develops a detailed content calendar with platform-optimized posts, creative assets, and copy that resonates with your specific target audience.',
      },
      {
        step: '03',
        title: 'Creation & Publishing',
        desc: 'We create all content in-house — design, copy, and scheduling — ensuring brand consistency and quality across every post on every platform.',
      },
      {
        step: '04',
        title: 'Paid Amplification',
        desc: 'Strategic paid social campaigns amplify your organic content to reach new, qualified audiences and accelerate growth beyond organic limitations.',
      },
      {
        step: '05',
        title: 'Monitor & Optimise',
        desc: 'We continuously analyze performance data and optimize both content and campaigns for better engagement, reach, and lead generation month after month.',
      },
    ],
    faq: [
      {
        q: 'Which social media platforms do you manage?',
        a: 'We manage Instagram, Facebook, LinkedIn, and Twitter/X, tailoring strategies to the platforms most relevant to your specific business and target audience.',
      },
      {
        q: 'How long before we see results?',
        a: 'Organic growth typically shows meaningful results within 3–4 months. Paid social campaigns can start generating results from the first week of launch.',
      },
      {
        q: 'Do you create content or do I need to provide it?',
        a: "We handle full content creation — design, copywriting, and video editing — all you need to provide is your brand guidelines and product or service information.",
      },
      {
        q: 'How do you measure success?',
        a: 'We track reach, engagement rate, follower growth, website traffic from social, lead generation volume, and cost per lead for paid campaigns.',
      },
    ],
  },
  {
    id: 'seo-optimization',
    slug: 'seo-optimization',
    title: 'SEO Optimization',
    icon: 'TrendingUp',
    shortDesc:
      'Rank higher on Google and drive sustainable organic traffic. Our technical and content SEO strategies ensure your business is discovered by the right audience at the right moment.',
    outcome: 'Increase organic search rankings and drive sustainable traffic',
    metaTitle: 'SEO Optimization Services India | SEO Agency | Markivox',
    metaDesc:
      'Professional SEO optimization services in India. Improve your Google rankings, drive sustainable organic traffic, and grow your business with Markivox.',
    heroH1: 'SEO Optimization Services That Drive Sustainable Organic Growth',
    intro: [
      "Search Engine Optimization (SEO) remains the most cost-effective long-term digital marketing strategy available to businesses today. When done correctly, SEO delivers a continuous stream of high-intent visitors to your website — people who are actively searching for exactly what you offer, at precisely the moment they need it.",
      "At Markivox, our SEO services are built on a foundation of technical excellence, quality content strategy, and ethical link-building practices that earn long-term rankings. We don't chase shortcuts or tactics that risk Google penalties — we build sustainable search visibility that compounds in value over time and continues delivering results long after the work is complete.",
      "From comprehensive technical audits to targeted keyword strategies and authoritative content creation, our SEO team covers every dimension of search optimization. We work with businesses across India to improve their organic visibility for the search terms their ideal customers use every day.",
    ],
    benefits: [
      {
        title: 'Higher Search Rankings',
        desc: 'We optimize your website to rank prominently for the keywords your customers search, positioning your business in front of high-intent audiences at the moment of decision.',
      },
      {
        title: 'Sustainable Organic Traffic',
        desc: 'Unlike paid advertising, quality SEO continues to deliver traffic long after the work is done, providing compounding returns that grow in value over time.',
      },
      {
        title: 'Local SEO Dominance',
        desc: 'For businesses targeting local customers, we optimize your Google Business Profile and local citations to dominate local search results and Google Maps listings.',
      },
      {
        title: 'Technical Excellence',
        desc: 'We identify and resolve technical issues that prevent search engines from properly crawling, indexing, and ranking your pages — from site speed to schema markup.',
      },
      {
        title: 'Content Authority',
        desc: 'Our content strategy establishes your website as a topical authority in your industry, earning trust from both search engines and the human visitors who convert into customers.',
      },
    ],
    process: [
      {
        step: '01',
        title: 'SEO Audit',
        desc: 'A comprehensive audit of your technical health, on-page optimization, content quality, and backlink profile to identify opportunities and prioritize actions.',
      },
      {
        step: '02',
        title: 'Keyword Research',
        desc: 'Identifying high-value keywords with the right balance of search volume, competition level, and commercial intent specifically aligned to your business goals.',
      },
      {
        step: '03',
        title: 'Technical Optimization',
        desc: 'Site speed improvements, mobile optimization, schema markup, URL structure refinement, and crawlability fixes to ensure flawless search engine access.',
      },
      {
        step: '04',
        title: 'On-Page Optimization',
        desc: 'Optimizing title tags, meta descriptions, heading structure, content depth, and internal linking for every key page to maximize relevance and ranking potential.',
      },
      {
        step: '05',
        title: 'Content & Link Building',
        desc: 'Creating high-quality content assets that attract organic backlinks while manually building authoritative links to strengthen your domain authority.',
      },
    ],
    faq: [
      {
        q: 'How long does SEO take to show results?',
        a: 'SEO is a long-term investment. Most businesses begin seeing meaningful ranking improvements in 3–6 months, with significant organic traffic growth typically visible within 6–12 months.',
      },
      {
        q: 'Do you guarantee first-page rankings?',
        a: "We don't guarantee specific rankings — no ethical SEO agency can. We guarantee implementing industry best practices and continuously working to improve your search positions.",
      },
      {
        q: 'Will SEO work for my local business?',
        a: 'Absolutely. Local SEO is one of the most powerful strategies for businesses serving specific geographic areas, including Google Business Profile optimization and local citation building.',
      },
      {
        q: 'How do you report SEO progress?',
        a: 'We provide detailed monthly reports showing keyword ranking movements, organic traffic growth, backlinks acquired, technical health scores, and goal completions.',
      },
    ],
  },
  {
    id: 'google-ads-management',
    slug: 'google-ads-management',
    title: 'Google Ads Management',
    icon: 'Target',
    shortDesc:
      'Get to the top of Google search results immediately with expertly managed PPC campaigns. We maximize your ad budget to deliver qualified leads at the lowest possible cost per acquisition.',
    outcome: 'Maximize ROI from Google Ads with optimized, data-driven campaigns',
    metaTitle: 'Google Ads Management Agency India | PPC Services | Markivox',
    metaDesc:
      'Expert Google Ads management services in India. Maximize ROI, reduce cost per lead, and grow your business with Markivox performance marketing.',
    heroH1: 'Google Ads Management That Maximizes ROI and Eliminates Wasted Spend',
    intro: [
      "Google Ads is the most direct and immediate path to placing your business in front of customers who are actively searching for your products or services. When a potential customer searches for what you offer on Google, a well-structured Ads campaign ensures your business appears at the top — exactly when their purchase intent is highest.",
      "Without expert management, however, Google Ads can rapidly consume budget with disappointing returns. Poorly structured campaigns, wrong keyword targeting, weak ad copy, and inadequate conversion tracking are among the most common reasons businesses fail to achieve ROI from Google Ads. At Markivox, our certified Google Ads specialists have managed significant ad spend across multiple industries, and we know exactly how to build and optimize campaigns that deliver measurable returns.",
      "From account architecture and keyword strategy to bid management and landing page optimization, we manage every dimension of your Google Ads presence with a relentless focus on reducing your cost per lead and improving your return on ad spend.",
    ],
    benefits: [
      {
        title: 'Immediate Search Visibility',
        desc: 'Unlike SEO, Google Ads delivers first-page placement immediately — driving qualified traffic and leads from the very first day your campaign goes live.',
      },
      {
        title: 'Precise Intent Targeting',
        desc: "We target customers by exact search intent, location, device, time of day, and demographics — reaching only the people most likely to become your customers.",
      },
      {
        title: 'Complete Budget Control',
        desc: "You only pay when someone clicks your ad. We optimize bids and targeting to ensure every click has the highest possible probability of converting into a lead or sale.",
      },
      {
        title: 'Comprehensive Conversion Tracking',
        desc: 'We implement detailed conversion tracking so you know precisely which keywords, ads, and campaigns are generating leads, calls, and revenue.',
      },
      {
        title: 'Continuous Performance Optimization',
        desc: 'Our team continuously tests ad copy variations, landing page elements, and bidding strategies to reduce cost per acquisition and improve campaign ROI month over month.',
      },
    ],
    process: [
      {
        step: '01',
        title: 'Account Audit & Architecture',
        desc: 'We audit existing accounts or set up new ones with the right campaign structure, tightly themed ad groups, and a logical keyword organization that improves Quality Scores.',
      },
      {
        step: '02',
        title: 'Keyword Strategy',
        desc: 'Identifying high-intent, commercial keywords with strong conversion potential while building comprehensive negative keyword lists to prevent irrelevant clicks and budget waste.',
      },
      {
        step: '03',
        title: 'Compelling Ad Creation',
        desc: 'Writing ad copy that speaks directly to customer needs, highlights your unique value proposition, and includes strong calls-to-action that drive qualified clicks.',
      },
      {
        step: '04',
        title: 'Landing Page Optimization',
        desc: 'Ensuring your landing pages are optimized for conversions — fast-loading, message-matched to ads, and designed with clear conversion paths.',
      },
      {
        step: '05',
        title: 'Ongoing Management & Reporting',
        desc: 'Continuous bid adjustments, budget optimization, search term analysis, and detailed monthly reports showing leads generated, cost per lead, and campaign ROI.',
      },
    ],
    faq: [
      {
        q: 'What monthly budget do I need for Google Ads?',
        a: 'We work with budgets starting from ₹25,000 per month. The ideal budget depends on your industry competitiveness, target keywords, and business growth goals.',
      },
      {
        q: 'How quickly will I see results from Google Ads?',
        a: 'Google Ads can start generating leads within the first week of launch. The first 30–60 days involve testing and optimization to improve performance progressively.',
      },
      {
        q: 'What ad types do you manage?',
        a: 'We manage Google Search Ads, Display Ads, Shopping Ads, and YouTube Ads depending on your business objectives and target audience behavior.',
      },
      {
        q: 'How do you prevent wasted ad spend?',
        a: 'Through meticulous negative keyword management, precise geographic and demographic targeting, ad scheduling, and continuous monitoring of search term reports.',
      },
    ],
  },
  {
    id: 'website-development',
    slug: 'website-development',
    title: 'Website Development',
    icon: 'Globe',
    shortDesc:
      'Build a fast, modern, conversion-optimized website that serves as the foundation of your digital marketing. From business websites to landing pages, we build with one purpose: results.',
    outcome: 'Build a high-converting website that actively drives business growth',
    metaTitle: 'Website Development Company India | Business Websites | Markivox',
    metaDesc:
      'Professional website development services in India. Fast, modern, SEO-ready business websites designed to convert visitors into customers. Markivox.',
    heroH1: 'Website Development That Converts Visitors Into Customers',
    intro: [
      "Your website is your most valuable and hardest-working marketing asset. It serves as the central hub of all your digital marketing activity — the destination for traffic from SEO, social media, Google Ads, and email marketing. A well-designed, technically sound, and conversion-optimized website doesn't just look professional; it actively and continuously works to turn visitors into leads and customers.",
      "At Markivox, we build websites with one primary objective: measurable business outcomes. Every design decision, information architecture choice, and call-to-action placement is made to move your visitors closer to taking the action that grows your business — whether that's filling a contact form, making a purchase, or picking up the phone.",
      "We combine strategic UX thinking with modern development practices to deliver websites that perform exceptionally on every device, load fast enough to retain impatient visitors, and rank well in search engines from launch day. Our websites are built to be the strongest asset in your digital marketing ecosystem.",
    ],
    benefits: [
      {
        title: 'Conversion-First Design',
        desc: "Our websites are designed around user journeys that guide visitors toward taking specific actions — calls, form submissions, or purchases — not just browsing.",
      },
      {
        title: 'SEO-Ready Architecture',
        desc: 'Built with proper technical SEO from the ground up — optimized page speed, structured data, semantic HTML, and mobile-first responsiveness.',
      },
      {
        title: 'Mobile-First Development',
        desc: 'With over 70% of web traffic originating from mobile devices, every website we build delivers a flawless experience on smartphones and tablets.',
      },
      {
        title: 'Brand-Aligned Aesthetics',
        desc: 'We create visual experiences that authentically reflect your brand values, build immediate trust, and differentiate you from competitors in your market.',
      },
      {
        title: 'Easy Content Management',
        desc: 'Powered by user-friendly content management systems that allow you to update content, add new pages, and manage your website without any technical knowledge.',
      },
    ],
    process: [
      {
        step: '01',
        title: 'Discovery & Planning',
        desc: 'Understanding your business goals, target audience, conversion requirements, and competitive landscape to define the right strategy and site architecture.',
      },
      {
        step: '02',
        title: 'Design & Wireframing',
        desc: 'Creating wireframes and high-fidelity mockups that prioritize user experience and conversion, reviewed and approved by you before development begins.',
      },
      {
        step: '03',
        title: 'Development',
        desc: 'Building your website with clean, efficient code using modern frameworks optimized for speed, security, accessibility, and long-term scalability.',
      },
      {
        step: '04',
        title: 'Content & SEO Integration',
        desc: 'Integrating optimized content, meta tags, structured data, image optimization, and all technical SEO foundations for search engine readiness at launch.',
      },
      {
        step: '05',
        title: 'Launch & Ongoing Support',
        desc: 'Thorough cross-device and cross-browser testing, followed by a careful launch process and training on how to manage and update your new website.',
      },
    ],
    faq: [
      {
        q: 'How long does it take to build a website?',
        a: 'A standard business website typically takes 4–6 weeks from strategy to launch. More complex projects with custom features or large content volumes may take 8–12 weeks.',
      },
      {
        q: 'Do you provide hosting and domain services?',
        a: 'We provide guidance on selecting the right hosting and domain providers, and ensure your website is optimized to perform on any quality hosting environment.',
      },
      {
        q: 'Will I be able to update my website myself?',
        a: 'Yes. We build on user-friendly CMS platforms and provide thorough training so you can confidently manage and update your content without technical assistance.',
      },
      {
        q: 'Do you redesign existing websites?',
        a: 'Absolutely. Website redesigns are a significant part of our practice. We audit your existing site and rebuild it to modern standards while carefully preserving existing SEO value.',
      },
    ],
  },
  {
    id: 'marketing-strategy',
    slug: 'marketing-strategy',
    title: 'Marketing Strategy & Consulting',
    icon: 'Lightbulb',
    shortDesc:
      'Get strategic clarity on your marketing direction. We help businesses define their positioning, identify the right channels, and build a clear roadmap for measurable, sustainable growth.',
    outcome: 'Develop a focused marketing roadmap aligned with your business goals',
    metaTitle: 'Digital Marketing Strategy & Consulting India | Markivox',
    metaDesc:
      'Expert digital marketing strategy and consulting services in India. Build a clear growth roadmap, optimize budget allocation, and gain competitive advantage with Markivox.',
    heroH1: 'Marketing Strategy & Consulting for Businesses Ready to Grow Smarter',
    intro: [
      "Effective marketing execution without a solid strategy is like driving fast in the wrong direction — you'll get somewhere quickly, but it won't be where you want to go. Marketing strategy is the critical thinking work that makes every execution decision more effective, every rupee of budget more efficient, and every campaign outcome more predictable.",
      "At Markivox, our consulting services help businesses at every stage — from startups mapping out their go-to-market approach to established companies looking to scale or enter new markets — develop clear, actionable marketing strategies that drive genuine business growth. We bring analytical rigor, industry experience, and an objective perspective to help you make smarter marketing decisions with confidence.",
      "Our strategy work is practical by design. We don't produce strategy documents that gather dust; we create implementable roadmaps with clear priorities, accountability structures, and measurable success metrics that guide your marketing team or serve as the foundation for working with us on execution.",
    ],
    benefits: [
      {
        title: 'Strategic Clarity',
        desc: 'Eliminate confusion about which marketing channels to prioritize, what messages resonate, and how to allocate your marketing budget for maximum business impact.',
      },
      {
        title: 'Competitive Positioning',
        desc: 'Understand your competitive landscape in depth and define a clear positioning that genuinely differentiates your brand in ways that matter to your target customers.',
      },
      {
        title: 'Smarter Budget Allocation',
        desc: 'Make data-informed decisions about marketing investment based on industry benchmarks, channel performance data, and your specific business stage and goals.',
      },
      {
        title: 'Right Channel Selection',
        desc: "Identify the optimal marketing channel mix for your audience and business stage, avoiding the common trap of trying to maintain a presence everywhere at once.",
      },
      {
        title: 'Actionable Growth Roadmap',
        desc: 'Walk away with a clear 6–12 month marketing roadmap featuring prioritized initiatives, defined KPIs, budget allocation, and accountability frameworks.',
      },
    ],
    process: [
      {
        step: '01',
        title: 'Business Discovery',
        desc: 'In-depth sessions to understand your business model, revenue goals, current challenges, existing marketing efforts, and the competitive environment you operate in.',
      },
      {
        step: '02',
        title: 'Audience Research',
        desc: 'Developing detailed, evidence-based customer personas to ensure all marketing strategy and subsequent execution is precisely targeted at the right people.',
      },
      {
        step: '03',
        title: 'Market Analysis',
        desc: 'Competitive analysis, market sizing, channel opportunity assessment, and trend analysis to identify where the most significant growth opportunities exist.',
      },
      {
        step: '04',
        title: 'Strategy Development',
        desc: 'Creating a comprehensive marketing strategy covering brand positioning, messaging framework, channel selection, content strategy, and budget allocation.',
      },
      {
        step: '05',
        title: 'Roadmap & Handoff',
        desc: 'Translating strategy into a practical quarterly roadmap with clear priorities, milestones, success metrics, and a path to implementation.',
      },
    ],
    faq: [
      {
        q: 'Who is marketing strategy consulting for?',
        a: "Our consulting is ideal for businesses where current marketing isn't delivering expected returns, startups planning go-to-market strategy, and established businesses entering new markets or scaling.",
      },
      {
        q: 'What is the typical engagement duration?',
        a: 'Initial strategy engagements typically run 4–6 weeks. Ongoing strategic advisory retainers are available for businesses seeking continued guidance.',
      },
      {
        q: 'Do you help with implementation after strategy?',
        a: 'Yes. Many clients transition from strategy consulting to ongoing execution services — social media, SEO, or Google Ads — with the same Markivox team.',
      },
      {
        q: 'What makes your approach different?',
        a: "We combine analytical rigor with hands-on execution experience. Our strategies are built to be implemented, not just presented — because we know what actually works in practice.",
      },
    ],
  },
];

export const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);
